import Prism from './vendor/prism';
import defaultProps from './defaultProps';
import Highlight from './components/Highlight';
export { Prism, defaultProps };
export default Highlight;